import { render, staticRenderFns } from "./UserChangePass.vue?vue&type=template&id=7433a56c&"
import script from "./UserChangePass.vue?vue&type=script&lang=js&"
export * from "./UserChangePass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports